import { Box, Flex, Text } from '@chakra-ui/react';
import { Button, Modal } from '@morressier/alembic';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/pro-regular-svg-icons';

interface Props {
  onDelete: () => void;
  onClose: () => void;
  selectedAuthors: string[];
  isOpen: boolean;
}

export const DeleteAuthorsModal = ({
  onDelete,
  onClose,
  selectedAuthors,
  isOpen
}: Props) => {
  return (
    <Modal
      onClose={onClose}
      isOpen={isOpen}
      width="450px"
      closeButtonProps={{
        hidden: true
      }}
    >
      <Flex flexDirection={'column'} gap={4} padding={8}>
        <Box fontSize="40px" color={'actionSecondaryCautionContent'}>
          <FontAwesomeIcon icon={faExclamationTriangle} fontSize="42px" />
        </Box>
        <Text textStyle="headingGroup">Delete Authors ?</Text>
        <Text textStyle="textBody">
          Are you certain you want to delete {selectedAuthors.length} author
          {selectedAuthors.length !== 1 ? 's' : ''}? This action cannot be
          undone.
        </Text>
        <Flex flexDirection={'row'} gap={2} justifyContent="flex-end">
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="caution" onClick={onDelete}>
            Delete
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};
